import { createContext, useContext, useMemo } from "react";

const ClientContext = createContext(undefined);

const clients = {
  "averon.co.ke": {
    name: "Averon Pharmacy",
    logo: "/assets/images/logo/averon.png",
    favicon: "/averon.ico",
    contact: "254702585388",
    title:
      "Averon Pharmacy | Online Pharmaceutical Marketplace & Medicine Delivery",
  },

  "makadarachem.co.ke": {
    name: "Makadara Chemist",
    logo: "/assets/images/logo/makadara-chemist-logo.svg",
    favicon: "/favicon.png",
    contact: "254720822049",
    title:
      "Makadara Chemist | Online Pharmaceutical Marketplace & Medicine Delivery",
  },

  default: {
    name: "phAMACart",
    logo: "/assets/images/logo/phamacart.png",
    favicon: "/favicon.png",
    contact: "254725027002",
    title: "phAMACart | Online Pharmaceutical Marketplace & Medicine Delivery",
  },
};

export function ClientProvider({ children }) {
  const host = window.location.host;

  const client = useMemo(() => {
    return clients[host] || clients.default;
  }, [host]);

  return (
    <ClientContext.Provider value={client}>{children}</ClientContext.Provider>
  );
}

export function useClient() {
  const context = useContext(ClientContext);

  if (context === undefined) {
    throw new Error("useClient must be used within a ClientProvider");
  }

  return context;
}
